/* eslint-disable no-nested-ternary */
import { FC } from 'react';
import Select from 'react-select';

export interface SimpleSelectProps {
  onChange?: (e: any) => void;
  onBlur?: (e: any) => void;
  options?: any;
  placeholder?: string | undefined;
  [x: string]: any;
  value?: any;
  defaultValue?: any;
  disabled?: boolean;
  isError?: boolean;
  menuPlacement?: string;
  isSearchable?: boolean;
  isWhiteBg?: boolean;
  isShortMenu?: boolean;
  isFormAppearance?: boolean;
}

export const SimpleSelect: FC<SimpleSelectProps> = ({
  options,
  onChange,
  onBlur,
  value,
  defaultValue,
  placeholder = 'select',
  restProps,
  disabled = false,
  isError = false,
  menuPlacement = 'bottom',
  isSearchable,
  isWhiteBg = true,
  isShortMenu = false,
  isFormAppearance = false,
}: SimpleSelectProps) => {
  const customStyles = {
    control: (provided: any, state: any) => ({
      ...provided,
      height: 32,
      fontSize: 16,
      borderRadius: 4,
      paddingLeft: 12,
      border: isError ? '1px solid red' : '1px solid white',
      backgroundColor: isWhiteBg ? 'white' : '#F9FAFB',
      fontWeight: isFormAppearance ? 400 : 600,
      boxShadow: state.isFocused ? '0 0 0 1px #C40D42' : 'none',
      borderColor: state.isFocused ? '#C40D42' : isError ? 'red' : 'white',
      '&:hover': {
        borderColor: 'white',
      },
    }),
    option: (styles: any, { isDisabled, isFocused, isSelected }: any) => ({
      ...styles,
      color: '#C40D42',
      backgroundColor: isSelected ? '#ecdadf' : isFocused ? '#ecdadf' : 'white',
      cursor: isDisabled ? 'not-allowed' : 'pointer',
    }),
    menu: (provided: any) => ({
      ...provided,
      maxHeight: isShortMenu ? 100 : 150,
      overflowY: 'auto',
    }),
    dropdownIndicator: (provided: any, state: any) => ({
      ...provided,
      color: '#C40D42',
      '&:hover': {
        color: '#C40D42',
      },
    }),
    indicatorSeparator: () => ({
      display: 'none',
    }),
  };

  return (
    <Select
      menuPlacement={menuPlacement}
      styles={customStyles}
      options={options}
      className="sd-classes-select"
      placeholder={placeholder}
      theme={(theme: any) => ({
        ...theme,
        borderRadius: 10,
        colors: {
          ...theme.colors,
          primary25: '#C40D42', // option Hover colour
          neutral80: isFormAppearance ? '#737791' : '#C40D42', // typing Inside the select
          neutral20: 'white', // Outline colour
          primary: 'white',
          neutral30: 'white',
        },
      })}
      onChange={onChange}
      onBlur={onBlur}
      value={value}
      defaultValue={defaultValue}
      isDisabled={disabled}
      isSearchable={isSearchable}
      {...restProps}
    />
  );
};

export default SimpleSelect;
